import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { closeCustomDialogAction } from 'redux/slices/customDialogSlice';
import { addProductAction, requestProductRefresh } from 'redux/slices/productSlice';
import ProductForm from './ProductForm';

const ProductCreate = (props) => {
    const { formConfigProduct, formConfigProductVariant, onCancel, onComplete } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const product = {
        category: 'demo',
        name: '',
        description: '',
        descriptionHtml: '',
        enableVariants: false,
        tags: [],
        images: [],
        variants: [],
        options: [],
        discountType: 'none',
        discount: null,
        sku: '',
        gtin: '',
    };

    const handleSubmit = (data, callback) => {
        data.description = data.descriptionHtml;
        dispatch(
            addProductAction(data, (product) => {
                try {
                    onComplete?.(product);
                } catch (error) {
                    console.error(`Error calling product edit onComplete callback: ${error.message}`);
                }
                if (callback) {
                    callback();
                }
                dispatch(requestProductRefresh());
                dispatch(closeCustomDialogAction());
            }),
        );
    };

    return (
        <ProductForm
            action={t('product.productCreate.new')}
            product={product}
            onSubmit={handleSubmit}
            formConfigProduct={formConfigProduct}
            formConfigProductVariant={formConfigProductVariant}
            canEdit={true}
            onCancel={onCancel}
        />
    );
};

export default ProductCreate;
